import styled from "styled-components";

export const TitleWrap = styled.div`
   display:flex;
   background: linear-gradient(180deg, #0B1B29 -147.57%, #554176 183.93%);
   padding:40px 0;
   margin-bottom:24px;

   h2{
    width:1200px;
    margin:0 auto;
    color:#fff;
    font-size:32px;
    font-weight:900;
   }
  }
`;